import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { profileQKeys } from "@hooks/queries/profile/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateProfile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (profileData: FormData) => {
      return api.post("profile/", profileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "create-profile-success",
      });
      queryClient.invalidateQueries({
        queryKey: profileQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Profile]", res);
      handleErrors(res, "mutation");
    },
  });
};
